import React from 'react';
import '../../FormBuilder.css';

const LoggedUserElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'loggedUser' && (
        <label className='titleTextLbl'>
            {component.fieldName || "LoggedUser"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default LoggedUserElement;
